import { CheckIcon, Paragraph } from '@buffer-mono/popcorn'

import styles from './SuccessOverlay.module.css'

import type { JSX } from 'react'

export function SuccessOverlay(): JSX.Element {
  return (
    <div role="alert" className={styles.overlay}>
      <div className={styles.check} aria-hidden>
        <CheckIcon />
      </div>
      <Paragraph align="center" className={styles.message}>
        Your feedback has been received. <br />
        Thank you!
      </Paragraph>
    </div>
  )
}
